
import { Component, Vue } from "vue-property-decorator";
import { Getter } from 'vuex-class';
import Logo from "./components/Logo.vue";
import SendSmsCode from "@/components/SendSmsCode/index.vue";
import MessageProtectPopup from "./components/MessageProtectPopup.vue";
import ContractPopup from "./components/ContractPopup.vue";
import { registOrLoginphone } from '@/api/login'
import { encryptData } from "@/utils/encryptData";
import { validatePhoneNumber } from "@/utils/util";
import { pxToVw } from '@/utils/pxToVw'
import { enterSystem } from './login'
import store from '@/store'
import { setAllowsBackGesture } from "@/utils/h5ToApp";

@Component({
  components: { Logo, SendSmsCode, MessageProtectPopup, ContractPopup }
})
export class Login extends Vue {
  @Getter isAgreeMessageProtect!: boolean;
  @Getter topSafetyHeight!: number

  mobile = ''
  smsCode = ''
  businessId = ''
  isAgree = false
  errShakeClass = 'animate__animated animate__headShake'
  isMobileErr = false
  mobileErrMsg = '请输入正确的手机号码格式'
  isSmsCodeErr = false
  registOrLoginData = null // 登录/注册成功获取到的数据

  get topSafetyHeightCss (): string {
    return pxToVw(this.topSafetyHeight)
  }

  created () {
    this.$store.commit('addKeepAlive', 'Login')
  }

  mounted () {
    // 禁用侧滑返回
    setAllowsBackGesture('0');
    // 如果不同意个人信息保护提示要弹弹窗，否则不弹
    if (!this.isAgreeMessageProtect) {
      (this.$refs.messageProtectPopupRef as any).showPopup()
    }
  }

  onMobileFocus () {
    this.isMobileErr = false
  }

  onMobileBlur (value: string) {
    if (value) {
      this.isMobileErr = !validatePhoneNumber(value)
      this.mobileErrMsg = '请输入正确的手机号码格式'
    }
  }

  onSendSmsCodeApiRes (res: any) {
    if (res.code === "000000") {
      this.businessId = res.data.businessId
    } else {
      this.mobileErrMsg = res.data.msg
      this.isMobileErr = true
    }
  }

  toPath (path: string) {
    this.$router.push(path)
  }

  onLoginOrRegister () {
    this.isSmsCodeErr && (this.isSmsCodeErr = false)
    if (!this.businessId) {
      this.$toast("请先获取验证码");
      return
    }
    const params = {
      mobile: encryptData(this.mobile),
      smsCode: this.smsCode,
      businessId: this.businessId
    }
    registOrLoginphone(params).then((res) => {
      this.registOrLoginData = res.data
      if (!this.isAgree) {
        (this.$refs.contractPopupRef as any).showPopup()
        return
      }
      this.registOrLoginSuccess()
    }).catch((err) => {
      const { code, msg = '请联系管理员' } = err.data || null
      if (code === '000001') {
        if (msg.includes('验证码') || msg === '0') { // 验证码有误（红字提示即可）
          this.isSmsCodeErr = true
        } else { // 其他错误（toast提示）
          this.$toast(msg)
        }
      }
    })
  }

  registOrLoginSuccess () {
    // 缓存信息
    store.dispatch('GetInfo', this.registOrLoginData)
    store.dispatch('setFirstUserId', this.registOrLoginData.userId)
    this.$store.commit('delKeepAlive', 'Login')
    // 新注册用户设置密码
    if (this.registOrLoginData?.isRegistry == 1) {
      this.$router.replace(`/setPwd?businessId=${this.businessId}&mobile=${this.mobile}&smsCode=${this.smsCode}`)
    } else {
      // 进入系统
      enterSystem('login')
    }
  }

  onPwdLogin () {
    this.$router.replace('/pwdLogin')
    this.$store.commit('delKeepAlive', 'Login')
  }

  onYesContract () {
    this.isAgree = true
    this.registOrLoginSuccess()
  }
}
export default Login
